<template>
  <div>
    <div class="container file" v-if="fileUrl">
      <div class="file--tit">첨부파일</div>
      <div class="file--down" @click="downloadFile">
        {{ fileName }} <span>{{ fileSize }}</span>
      </div>
    </div>
    <div class="navi-detail-style">
      <div class="container">
        <div class="row">
          <div class="col-4">
            <a
              v-if="prevId"
              href
              @click.prevent="prevDetail"
              class="navi-detail-style-prev"
              ref="btn"
              >이전글</a
            >
          </div>
          <div class="col-4 navi-detail-style-center">
            <a href @click.prevent="goToList" ref="btnList" class="navi-detail-style-list" :class="{footOpen: this.isFootState.value}"
              >목록</a
            >
          </div>
          <div class="col-4 navi-detail-style-right">
            <a
              v-if="nextId"
              href
              @click.prevent="nextDetail"
              class="navi-detail-style-next"
              ref="btn02"
              >다음글</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import downloadApi from '@/apis/download';

export default {
  name: 'NaviDetailBottom',
  props: {
    prevId: {
      type: Number,
      default: null,
    },
    nextId: {
      type: Number,
      default: null,
    },
    news: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    fileName() {
      const { news } = this;
      return news != null && news.attachingFileName != null ? news.attachingFileName : null;
    },
    fileUrl() {
      const { news } = this;
      return news != null && news.attachingFileUrl != null ? news.attachingFileUrl : null;
    },
    fileSize() {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const { news } = this;
      if (news == null) {
        return null;
      }
      if (news.attachingFileSize == null) {
        return null;
      }
      const kb = 1024;
      const fileSize = parseInt(news.attachingFileSize, 10);
      if (fileSize === 0) {
        return '0 Byte';
      }
      const index = Math.floor(Math.log(fileSize) / Math.log(kb));

      return `${parseFloat((fileSize / kb ** index).toFixed(2))} ${sizes[index]}`;
    },
  },
  inject: ['isFootState'], /* 모바일 > 뉴스/라이브러리 > 상세 > 목록 버튼이 푸터가 열렸을 때와 안열렸을 때 위치를 잡기 위한 값 */
  methods: {
    downloadFile() {
      downloadApi.downloadFile(this.fileUrl, this.fileName);
    },
    goToList() {
      const parameters = {};
      return this.$router.push({
        name: 'News',
        params: parameters,
      });
    },
    prevDetail() {
      this.$emit("prevDetail");
    },
    nextDetail() {
      this.$emit("nextDetail");
    },
    scrollFunc() {
      const currentY = document.documentElement.scrollTop;
      const viewHeight = document.documentElement.clientHeight;
      const allHeight = document.body.clientHeight;
      // const currentHeight = currentY + viewHeight;
      if(currentY > allHeight - viewHeight - 400) {
        if(this.$refs.btn){
          this.$refs.btn.classList.add('bottom');
        }
        if(this.$refs.btn02){
          this.$refs.btn02.classList.add('bottom');
        }
      }else{
        if(this.$refs.btn){
          this.$refs.btn.classList.remove('bottom');
        }
        if(this.$refs.btn02){
          this.$refs.btn02.classList.remove('bottom');
        }
      }
      if(currentY > allHeight - viewHeight) {
        this.$refs.btnList.classList.add('bottom');
      }else{
        this.$refs.btnList.classList.remove('bottom');
      }
    }
  },
  created() {
    window.addEventListener('scroll', this.scrollFunc);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollFunc);
  },
};
</script>

<style scoped>
  .file--down {
    cursor: pointer;
  }
</style>